import { styled } from '@mui/material/styles';
import { Avatar } from 'shared/mui/Avatars';

export const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 20,
  height: 20,
  border: `1px solid ${theme.palette.background.paper}`,
  backgroundColor: theme.palette.background.default,
  boxSizing: 'content-box',
}));
